export default "__VITE_ASSET__BMTt8ygE__"